var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lines.length
    ? _c(
        "g",
        { staticClass: "export-info", attrs: { "data-testid": "export-info" } },
        _vm._l(_vm.lines, function (line, index) {
          return _c(
            "text",
            {
              key: line,
              attrs: {
                "data-testid": "export-info-line",
                x: 10 * _vm.sizeScale,
                y: (20 + index * 20) * _vm.sizeScale,
                "font-size": 14 * _vm.sizeScale,
                "stroke-width": 3 * _vm.sizeScale,
                stroke: "white",
                fill: "#333",
                "font-family": "sans-serif",
                "font-weight": "bold",
                "paint-order": "stroke fill",
              },
            },
            [_vm._v("\n    " + _vm._s(line) + "\n  ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }